__turbopack_context__.v({
  "root": "reader-overlay-module__ijyckG__root",
});
